/* ngInject */
function CopyGuestLinkController ($scope, $translate, ToastService) {
  function activate () {}

  activate()

  $scope.copyLinkToClipboard = link => {
    navigator.clipboard.writeText(link)
    ToastService.showSuccessToast($translate.instant('copied'))
  }
}

export { CopyGuestLinkController }
